import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Logo } from '../assets/icons';
const Navigation = () => {

    const [handleDrop, setHandleDrop] = useState(false);

    const handleDropDown = () => {
        setHandleDrop(!handleDrop);
    }

    // Gather location information
    const location = useLocation()

    // State for opening navigation
    const [navbar, setNavbar] = useState(false);
    const handleNav = (e) => {
        e.preventDefault()
        setNavbar(!navbar)
    }
    return (
        <nav className="mx-auto w-full bg-white bg-opacity-80 fixed z-50 pt-2">

            <div className="md:w-10/12 w-full md:px-0 px-5 pt-1 mx-auto flex justify-between items-center bg-opacity-80">
                <div className="flex w-20 justify-center">
                    <img src={Logo} />
                </div>
                <div className="md:flex justify-aroud  items-center hidden">
                    <Link className={`ml-10 text-lg text-primary pb-2 ${location.pathname === '/' ? `font-bold border-b-2 border-primary` : ``}`} to="/">Beranda</Link>
                    <Link className={`ml-10 text-lg text-primary pb-2 ${location.pathname === '/aboutus' ? `font-bold border-b-2 border-primary` : ``}`} to="/aboutus">Tentang Kami</Link>
                    <Link className={`ml-10 text-lg text-primary pb-2 ${location.pathname === '/layanan' ? `font-bold border-b-2 border-primary` : ``}`} to="/layanan">Layanan</Link>
                    {/* <Link className={`ml-10 text-lg text-primary pb-2 ${location.pathname === '/portofolio' ? `font-bold border-b-2 border-primary` : ``}`} to="/portofolio">Portofolio</Link> */}
                    <Link className={`ml-10 text-lg text-primary pb-2 ${location.pathname === '/contactus' ? `font-bold border-b-2 border-primary` : ``}`} to="/contactus">Hubungi Kami</Link>
                </div>
                <div className="md:hidden">
                    <a href="#" onClick={handleNav}>
                        {navbar ?
                            (<svg xmlns="http://www.w3.org/2000/svg" className="h-11 w-11 text-primary" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>)
                            :
                            (<svg xmlns="http://www.w3.org/2000/svg" className="h-11 w-11 text-primary" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd" />
                            </svg>)}

                    </a>
                </div>
            </div>
            {navbar ?
            <div className={`w-screen h-screen fixed bg-primary bg-opacity-90`}>
                <div className="font-sans">
                    <ul className="flex-col w-screen h-screen text-center pt-32 justify-around items-center text-xl tracking-wide text-white">
                        <li onClick={handleNav} className="mr-8 py-3 font-normal text-gray hover:text-white" >
                            <Link className={`ml-10 text-lg ${location.pathname === '/' ? `font-extrabold text-slate-200` : ``}`} to="/">Beranda</Link>
                        </li>
                        <li onClick={handleNav} className="mr-8 py-3 font-normal text-gray hover:text-white">
                            <Link className={`ml-10 text-lg ${location.pathname === '/aboutus' ? `font-extrabold text-slate-200 ` : ``}`} to="/aboutus">Tentang Kami</Link>
                        </li>
                        <li onClick={handleNav} className="mr-8 py-3 font-normal text-gray hover:text-white">
                            <Link className={`ml-10 text-lg ${location.pathname === '/layanan' ? `font-extrabold text-slate-200 ` : ``}`} to="/layanan">Layanan</Link>
                        </li>
                        {/* <li onClick={handleNav} className="mr-8 py-3 font-normal text-gray hover:text-white">
                            <Link className={`ml-10 text-lg ${location.pathname === '/portofolio' ? `font-extrabold text-slate-200` : ``}`} to="/portofolio">Portofolio</Link>
                        </li> */}
                        <li onClick={handleNav} className="mr-8 py-3 font-normal text-gray hover:text-white">
                            <Link className={`ml-10 text-lg ${location.pathname === '/contactus' ? `font-extrabold text-slate-200` : ``}`} to="/contactus">Hubungi Kami</Link>
                        </li>
                    </ul>
                </div>
            </div>
            : null }

        </nav>
    )
}

export default Navigation
